export default {
  addBankAccount: 'Add bank account',
  accountNumber: 'Account Number',
  bank: 'Bank',
  carNumber: 'Card Number',
  account: 'Account',
  editBankAccount: 'Edit bank account',
  branchCode: 'Branch code',
  branchName: 'Branch name',
  cardNumber: 'Card mumber',
  holderName: 'Holder name',
  shebaNumber: 'Sheba number',
  createWasSuccessful: 'Bank account added successfully',
  editWasSuccessful: 'Bank account edited successfully',
  deleteAccountWasSuccessful: 'Bank account deleted successfully',
  bankAccount: 'Bank account'
}
